export default [
  {
    "id": "japan",
    "color": "hsl(28, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 250
      },
      {
        "x": "helicopter",
        "y": 67
      },
      {
        "x": "boat",
        "y": 291
      },
      {
        "x": "train",
        "y": 157
      },
      {
        "x": "subway",
        "y": 156
      },
      {
        "x": "bus",
        "y": 236
      },
      {
        "x": "car",
        "y": 127
      },
      {
        "x": "moto",
        "y": 295
      },
      {
        "x": "bicycle",
        "y": 280
      },
      {
        "x": "others",
        "y": 203
      }
    ]
  },
  {
    "id": "france",
    "color": "hsl(38, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 201
      },
      {
        "x": "helicopter",
        "y": 35
      },
      {
        "x": "boat",
        "y": 105
      },
      {
        "x": "train",
        "y": 110
      },
      {
        "x": "subway",
        "y": 3
      },
      {
        "x": "bus",
        "y": 41
      },
      {
        "x": "car",
        "y": 226
      },
      {
        "x": "moto",
        "y": 275
      },
      {
        "x": "bicycle",
        "y": 200
      },
      {
        "x": "others",
        "y": 131
      }
    ]
  },
  {
    "id": "us",
    "color": "hsl(118, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 155
      },
      {
        "x": "helicopter",
        "y": 29
      },
      {
        "x": "boat",
        "y": 212
      },
      {
        "x": "train",
        "y": 147
      },
      {
        "x": "subway",
        "y": 294
      },
      {
        "x": "bus",
        "y": 220
      },
      {
        "x": "car",
        "y": 147
      },
      {
        "x": "moto",
        "y": 32
      },
      {
        "x": "bicycle",
        "y": 200
      },
      {
        "x": "others",
        "y": 16
      }
    ]
  },
  {
    "id": "germany",
    "color": "hsl(16, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 177
      },
      {
        "x": "helicopter",
        "y": 191
      },
      {
        "x": "boat",
        "y": 202
      },
      {
        "x": "train",
        "y": 125
      },
      {
        "x": "subway",
        "y": 200
      },
      {
        "x": "bus",
        "y": 41
      },
      {
        "x": "car",
        "y": 215
      },
      {
        "x": "moto",
        "y": 75
      },
      {
        "x": "bicycle",
        "y": 138
      },
      {
        "x": "others",
        "y": 55
      }
    ]
  },
  {
    "id": "norway",
    "color": "hsl(261, 70%, 50%)",
    "data": [
      {
        "x": "plane",
        "y": 168
      },
      {
        "x": "helicopter",
        "y": 23
      },
      {
        "x": "boat",
        "y": 136
      },
      {
        "x": "train",
        "y": 164
      },
      {
        "x": "subway",
        "y": 141
      },
      {
        "x": "bus",
        "y": 215
      },
      {
        "x": "car",
        "y": 227
      },
      {
        "x": "moto",
        "y": 300
      },
      {
        "x": "bicycle",
        "y": 91
      },
      {
        "x": "others",
        "y": 231
      }
    ]
  }
]